<template>
  <b-navbar
    :toggleable="false"
    class="global-navbar sticky-top"
    :class="{ 'navbar--search-expanded': searchExpanded }"
  >
    <b-container class="nav-container">
      <!-- Left section: Logo and Burger -->
      <div 
        class="navbar-left"
        :class="{ 'navbar-left--no-burger': !userIsLoggedIn }"
      >
        <router-link
          :to="{ name: 'home' }"
          class="navbar-brand d-none d-xl-flex"
        >
          <svg-icon
            aria-label="caerus logo, click to go to home page"
            name="caerus-logo-navbar-light"
            width="122"
            height="35"
            role="button"
          />
          <span class="sr-only">Navigate to home</span>
        </router-link>
        <div 
          v-if="userIsLoggedIn"
          class="mobile-nav-burger"
        >
          <mobile-navbar />
        </div>
      </div>

      <!-- Middle section: Search -->
      <div class="navbar-search">
        <slot name="search" />
      </div>

      <!-- Right section: Icons and Nav Items -->
      <b-navbar-nav class="navbar-right flex-gap-3">
        <slot />

        <b-nav-item
          class="d-none d-lg-flex"
          @click="openSupportLink"
        >
          <span>Support</span>
        </b-nav-item>
      
        <b-nav-item
          v-if="!userIsLoggedIn"
          class="d-none d-lg-flex"
          @click="openListServiceLink"
        >
          <span class="sr-only"> Opens new page to list your service</span>
          <span>List your service</span>
        </b-nav-item>

        <slot name="icon-items" />
      
        <!-- Messages -->
        <message-nav-item v-if="allows('messages') && !isServiceOnboarding" />
      
        <!-- Notifications -->
        <notification-nav-item v-if="allows('notifications') && !isServiceOnboarding" />
      
        <!-- Guest/Profile nav-items -->
        <guest-nav-item v-if="!userIsLoggedIn" />
      
        <profile-nav-item v-else-if="!isServiceOnboarding" />
      
        <b-nav-item
          v-else
          @click.prevent="logout"
        >
          <span>Sign out</span>
        </b-nav-item>
      </b-navbar-nav>
    </b-container>
  </b-navbar>
</template>

<script>
import '@/core/icons/caerus-logo-navbar-light'
import { mapGetters } from 'vuex'
import FavouriteNavItem from '@/core/layouts/global-layout/components/nav-items/FavouriteNavItem'
import MessageNavItem from '@/core/layouts/global-layout/components/nav-items/MessageNavItem'
import MobileNavbar from '@/core/layouts/global-layout/components/MobileNavbar'
import NotificationNavItem from '@/core/layouts/global-layout/components/nav-items/NotificationNavItem'
import GuestNavItem from '@/core/layouts/global-layout/components/nav-items/GuestNavItem'
import ProfileNavItem from '@/core/layouts/global-layout/components/nav-items/ProfileNavItem'
import BasketNavItem from '@/modules/basket/components/BasketNavItem'

export default {

  name: 'SharedNavigation',

  components: {
    FavouriteNavItem,
    GuestNavItem,
    MessageNavItem,
    MobileNavbar,
    NotificationNavItem,
    ProfileNavItem,
    BasketNavItem
  },

  provide() {
    return {
      handleSearchExpanded: (expanded) => {
        this.searchExpanded = expanded
      }
    }
  },

  data() {
    return {
      searchExpanded: false,
    }
  },

  computed: {
    ...mapGetters('auth', ['userIsLoggedIn', 'isServiceOnboarding']),
  },

  methods: {

    /**
     * Open List Service link in new tab
     */
    openListServiceLink() {
      window.open('https://www.caerus.scot/list-your-service', "_blank");
    },

    /**
     * Open support link in new tab
     */
    openSupportLink() {
      window.open('https://support.caerus.scot/portal/en-gb/home', "_blank");
    },

    logout () {
      this.$store.dispatch('auth/logout')
      .then(() => {
        this.$router.push({ name: 'home' })
      })
    },

  },
}
</script>
<style lang="scss">
// Ensure desktop navbar logo matches mobile exactly
.global-navbar .navbar-left .navbar-brand {
  @media (min-width: 1200px) {
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    font-size: 0 !important;
    line-height: 1 !important;
    white-space: normal !important;
    
    // Target the vue-svgicon component wrapper
    ::v-deep svg-icon {
      display: inline-block !important;
      width: 122px !important;
      height: 35px !important;
      flex-shrink: 0 !important;
      line-height: 0 !important;
    }
    
    // Target the actual SVG element inside
    ::v-deep svg-icon > svg,
    ::v-deep svg {
      width: 122px !important;
      height: 35px !important;
      max-width: 122px !important;
      max-height: 35px !important;
      min-width: 122px !important;
      min-height: 35px !important;
      display: block !important;
      flex-shrink: 0 !important;
    }
  }
}
</style>